import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import { ACCESS_TOKEN, LANG, WAREHOUSE } from '@/store/mutation-types'
import { Result } from '@/api/dto/Result'

// 创建 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
    timeout: 60000 // 请求超时时间
})

const err = (error) => {
    if (error === undefined || error.response === undefined) {
        notification.error({
            message: 'Network Error',
            description: '连接服务器失败!'
        })
    }

    if (error.response) {
        const data = error.response.data
        const token = Vue.ls.get(ACCESS_TOKEN)
        if (error.response.status === 403) {
            notification.error({
                message: 'Forbidden',
                description: data.message
            })
            return
        }
        if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
            notification.error({
                message: 'Unauthorized',
                description: 'Authorization verification failed'
            })
            store.dispatch('Logout').then(() => {
                setTimeout(() => {
                    window.location.reload()
                }, 1500)
            })
        }
    }

    return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
    const token = Vue.ls.get(ACCESS_TOKEN)
    if (token) {
        config.headers['Authorization'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    const warehouse = Vue.ls.get(WAREHOUSE)
    config.headers['whId'] = warehouse ? warehouse.id : null
    const lang = Vue.ls.get(LANG)
    config.headers['Accept-Language'] = lang ? lang : 'zh-CN'
    return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
    const result = new Result()
    result.success = response.data.success
    result.result = response.data.result
    if (response.headers['content-size']) {
        result.contentSize = parseInt(response.headers['content-size'])
    }
    if (!result.success) {
        notification.error({
            message: '业务错误',
            description: result.result
        })
    }
    return result
}, err)

const printService = axios.create({
    baseURL: 'http://127.0.0.1:30000', // api base_url
    timeout: 30000 // 请求超时时间
})

const printServiceErr = (error) => {
    if (error === undefined || error.response === undefined) {
        notification.error({
            message: '连接打印客户端失败',
            description: '请确认打印客户端已经打开'
        })
    }
    return Promise.reject(error)
}

printService.interceptors.response.use((response) => {
    const result = new Result()
    console.log(response)
    result.success = response.data.success
    result.result = response.data.data
    if (!result.success) {
        notification.error({
            message: '业务错误',
            description: response.data.message
        })
    }
    return result
}, printServiceErr)


const installer = {
    vm: {},
    install(Vue) {
        Vue.use(VueAxios, service)
        Vue.use(VueAxios, printService)
    }
}

export {
    installer as VueAxios,
    service as axios,
    printService as printService
}
